export function safeJsonParse<T>(value: string | null, fallback: T): T {
  if (!value) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
}

export function readStorage<T>(key: string, fallback: T): T {
  return safeJsonParse<T>(window.localStorage.getItem(key), fallback);
}

export function writeStorage<T>(key: string, value: T): void {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function createId(prefix: string): string {
  // stable-enough for UI demo CRUD; replace with server ids later
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

